import React from "react";
import { styled } from "@mui/material/styles";
import LoadingButton from '@mui/lab/LoadingButton';

const StyleButtonLoadingBlue = styled(LoadingButton)(({ variant, color }) => ({
  borderRadius: 8,
  "&:hover": {
    borderRadius: 8,
  },
  ...(variant === "contained" && {
    borderColor: "#007afe",
    color: "#ffffff",
    backgroundColor: "#007afe",
    borderRadius: 8,
    "&:hover": {
      borderColor: "#0046b7",
      backgroundColor: "#0046b7",
    },
  }),
  ...(variant === "outlined" && {
    borderColor: "#007afe",
    backgroundColor: "transparent",
    color: "#007afe",
    borderRadius: 8,
    "&:hover": {
      borderColor: "#0046b7",
    },
  }),
  ...(variant === "text" && {
    backgroundColor: "transparent",
    color: "#007afe",
    borderRadius: 8,
    "&:hover": {
      borderRadius: 8,
      backgroundColor: "#1976d20a",
    },
  }),
  ...(variant === "text" &&
    color === "secondary" && {
      backgroundColor: "transparent",
      color: "#212b36",
      borderRadius: 8,
      "&:hover": {
        borderRadius: 8,
        backgroundColor: "#1976d20a",
      },
    }),
}));

const ButtonLoadingBlue = (props) => {
  return <StyleButtonLoadingBlue {...props}>{props.children}</StyleButtonLoadingBlue>;
};

export default ButtonLoadingBlue;
